<app-boilerplate>
  <app-event-headline [event]="lrpEvent"/>
  <core-accordion [value]="currentStep! - 1" [linear]="true">
    <core-accordion-panel header="Select Your Booking Type">
      <div class="flex gap-4">
        @if (playerTicketsArray.length > 0){
          <div class="card w-[300px] text-center flex flex-col items-center">
            <h2>Player Bookings</h2>
            <div class="text-sm mb-3 h-16">
              Play the game your way and create your own story
              <p-progressbar [value]="calculateSpaces(lrpEvent?.eventsLimits?.playerLimit,lrpEvent?.eventsLimits?.playerBookings)" styleClass="mt-1" />
            </div>
            @if (soldOut(lrpEvent?.eventsLimits?.playerLimit,lrpEvent?.eventsLimits?.playerBookings)){
              <p class="font-semibold tracking-widest">SOLD OUT</p>
            }
            @else {
              <button  (click)="selectBookingType('player')" class=" hover:bg-green-400 border-green-600 border hover:text-white font-semibold p-3 cursor-pointer rounded-lg w-40" >Book To Play</button>
            }
          </div>
        }
        @if(crewTicketsArray.length > 0){
          <div class="card w-[300px] text-center flex flex-col items-center">
            <h2>Crew Bookings</h2>
            <div class="text-sm mb-3 h-16">
              Hero or villain, the game only runs with the help of it's crew
              <p-progressbar [value]="calculateSpaces(lrpEvent?.eventsLimits?.crewLimit,lrpEvent?.eventsLimits?.crewBookings)" styleClass="mt-1" />
            </div>
            @if (soldOut(lrpEvent?.eventsLimits?.crewLimit,lrpEvent?.eventsLimits?.crewBookings)){
              <p class="font-semibold tracking-widest">SOLD OUT</p>
            }
            @else {
              <button (click)="selectBookingType('crew')" class=" hover:bg-red-400 border-red-600 border hover:text-white font-semibold p-3 cursor-pointer rounded-lg w-40">Book To Crew</button>
            }
          </div>
        }
        @if(staffTicketsArray.length > 0){
          <div class="card w-[300px] text-center flex flex-col items-center">
            <h2>Staff Bookings</h2>
            <div class="text-sm mb-3 h-16">
              None of the glory, but vital to bringing our worlds to life
              <p class="text-xs text-lrpTicketRed">Staff tickets are typically invitation only.</p>
            </div>
            <button (click)="selectBookingType('staff')" class=" hover:bg-blue-400 border-blue-600 border hover:text-white font-semibold p-3 cursor-pointer rounded-lg w-40">Book To Staff</button>
          </div>
        }
      </div>
    </core-accordion-panel>
    <core-accordion-panel header="Choose Your Tickets">
      <div class="flex gap-4">
        @for (ticket of availableTickets(); track $index){
          <div class="card w-[200px] cursor-pointer transition-all ease-in-out" (click)="webBooking.selectedPrimaryTicket = ticket" [class.card-selected]="webBooking.selectedPrimaryTicket === ticket && currentStep === 2">
            <h2 class="text-center mt-1">{{ ticket.description }}</h2>
            <p class="text-center font-semibold">
              @if (ticket.cost === 0){
                <span class="tracking-wide">FREE</span>
              }
              @else {
              {{ ticket.cost | currency:'GBP'}}
            }
          </p>
        </div>
      }
    </div>
    @if (mealTickets.length > 0 || bunkTickets.length > 0){
      <h3>Additional Tickets</h3>
    }
    <div class="flex gap-4">
      @for (ticket of additionalTickets; track $index){
        <div class="card w-[200px] cursor-pointer" (click)="toggleSecondaryTicket(ticket)" [class.card-selected]="isTicketListed(ticket) && currentStep === 2">
          <h2 class="text-center mt-1">{{ ticket.name }}</h2>
          <p class="text-xs text-center">{{ ticket.description }}</p>
          <p class="text-center font-semibold">
            @if (ticket.cost === 0){
              <span class="tracking-wide">FREE</span>
            }
            @else {
            {{ ticket.cost | currency:'GBP'}}
          }
        </p>
      </div>
    }
  </div>
  <div class="flex py-6 gap-2">
    <button class="outline-button" (click)="currentStep = 1">Back</button>
    <button class="primaryButton" (click)="currentStep = 3" [disabled]="!webBooking.selectedPrimaryTicket">Next</button>
  </div>
</core-accordion-panel>
<core-accordion-panel header="Confirm Your Details">
  <div class="flex justify-end h-fit">
    <div class="w-[300px] mr-4">
      <h2>Your Choices</h2>
      <app-ticket-pill [includePrice]="true" [primaryTicket]="webBooking.selectedPrimaryTicket" [additionalTickets]="webBooking.selectedAdditionalTickets"/>
      @if ((webBooking.event?.organiser?.partnerFee ?? 0) > 0){
          <div class="text-end text-xs cursor-help" title="This fee helps to keep LRPTickets.co.uk running. We will always try to keep this cost as minimal as possible.">
              LRP Tickets Service Charge: {{ webBooking.event?.organiser?.partnerFee | currency:'GBP'}}
          </div>
      }
      <div class="font-semibold text-right border-t-2 pt-2 border-gray-100">
        Total: {{ ticketTotal | currency:'GBP' }}
      </div>
    </div>
    <div class="w-full px-3 flex flex-col border-gray-200 border-l-2">
      <h2>Who is this ticket for?</h2>
      <div class="flex">
        <div class="card w-[200px] m-2 p-3 bg-gray-100 border border-gray-200 rounded-lg  text-center cursor-pointer" [class.card-selected]="webBooking.bookingForSelf && currentStep === 3" (click)="webBooking.bookingForSelf = true">Myself</div>
        <div class="card w-[200px] m-2 p-3 bg-gray-100 border border-gray-200 rounded-lg pt-1 text-center cursor-pointer" [class.card-selected]="!webBooking.bookingForSelf && currentStep === 3" (click)="webBooking.bookingForSelf = false ">Someone else</div>
      </div>
      @if (!webBooking.bookingForSelf) {
        <div class="flex">
          <div>
            <p>To ensure we allocate the ticket correctly, please provide the name of the person you are booking for.</p>
            <div class="flex gap-2 w-full mb-3">
              <input type="text" class="form-input w-full" [ngModel]="webBooking.bookingFirstname" placeholder="Firstname" />
              <input type="text" class="form-input w-full" [ngModel]="webBooking.bookingSurname" placeholder="Surname" />
              <input type="text" class="form-input w-full" [ngModel]="webBooking.bookingEmail" placeholder="E-mail Address (Optional)" />
            </div>
          </div>
          <div>
          </div>
        </div>
      }
      <div>
        <h2>Do you want to display your booking to other attendees?</h2>
        <div class="flex relative">
          <div class="card w-[200px] m-2 p-3 bg-gray-100 border border-gray-200 rounded-lg  text-center cursor-pointer" [class.card-selected]="webBooking.displayBooking && webBooking.bookingForSelf && currentStep === 3" [class.cursor-not-allowed]="!webBooking.bookingForSelf" (click)="webBooking.displayBooking = true">Yes</div>
          <div class="card w-[200px] m-2 p-3 bg-gray-100 border border-gray-200 rounded-lg pt-1 text-center" [class.card-selected]="!webBooking.displayBooking && webBooking.bookingForSelf && currentStep === 3" [class.card-selected-forced]="!webBooking.bookingForSelf && currentStep === 3" (click)="webBooking.displayBooking = false">No</div>
        </div>
        @if (!webBooking.bookingForSelf) {
          <p class="text-sm text-gray-600">We value our players privacy so this option is not available when booking for someone else</p>
        }
      </div>
    </div>
  </div>
  <div class="py-6">
    <div class="flex py-6 gap-2">
      <button class="outline-button" (click)="currentStep = 2">Back</button>
      <button class="primaryButton" (click)="secureBooking()">Book your event!</button>
    </div>
  </div>
</core-accordion-panel>
<core-accordion-panel header="Payment">
  <div class="flex flex-col h-48">
    @if (returnedEventBooking){
      <app-paypal [eventBooking]="returnedEventBooking!"/>
    }
  </div>
  <div class="py-6">
    <button class="outline-button" (click)="currentStep = 3">Back</button>
  </div>
</core-accordion-panel>
</core-accordion>

<p-confirmdialog>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col p-4 items-center w-full gap-4">
      <p class="mb-3">To confirm your booking, please review your ticket choices below.</p>
      <p class="mb-3">Once booked, you will have 24 hours to complete your payment.</p>
      <app-divider class="w-full" [label]="bookingType!.slice(0,1).toUpperCase() + bookingType!.slice(1,bookingType!.length) + ' Booking'" />
      <app-ticket-pill class="my-1 flex gap-3 flex-wrap justify-center" [columnView]="false" [primaryTicket]="webBooking.selectedPrimaryTicket" [additionalTickets]="webBooking.selectedAdditionalTickets"/>
      <app-divider class="w-full" [label]="'Terms & Conditions'"/>
      <div class="flex flex-col gap-1 pb-4">
        <form [formGroup]="termsForm" action="">
          <div>
            <input type="checkbox" name="" id="site_terms" formControlName="siteTerms">
            <label class="ms-3" for="site_terms">I agree to LRPTickets.co.uk <a class="underline" routerLink="/terms" target="_blank">Terms & Conditions</a></label>
          </div>
          @if (lrpEvent?.eventHost?.eventSystem?.terms) {
            <div>
              <input type="checkbox" name="" id="system_terms" formControlName="systemTerms">
              <label class="ms-3" for="system_terms">I agree to {{ lrpEvent?.eventHost?.eventSystem?.name }} <a class="underline" routerLink="/system/{{lrpEvent?.eventHost?.eventSystem?.systemRef}}/terms" target="_blank">Terms & Conditions</a></label>
            </div>
          }
          @if (lrpEvent?.eventHost?.terms) {
            <div>
              <input type="checkbox" name="" id="host_terms" formControlName="hostTerms">
              <label class="ms-3" for="host_terms">I agree to the event organisers <a class="underline" routerLink="/terms" target="_blank">Terms & Conditions</a></label>
            </div>
          }
        </form>
      </div>
      <div class="flex w-full justify-end gap-3">
        <button class="outline-button" (click)="onReject()">Back</button>
        <button class="primaryButton" [disabled]="!ableToBook()" (click)="onAccept()">Secure My Booking!</button>

      </div>
    </div>
  </ng-template>
</p-confirmdialog>
</app-boilerplate>